/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'embedded-confluence-common.src.content.empty-state-description': 'We hebben overal gezocht, maar de pagina bestaat niet. Het kan zijn dat deze verwijderd is. Tenzij de URL een typefout bevat 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'We konden niet vinden wat je zocht',
  'embedded.confluence.already-logged-in-paragraph': 'Al ingelogd? Probeer te vernieuwen.',
  'embedded.confluence.footer.hover.text': 'Weergeven in Confluence',
  'embedded.confluence.footer.prefix': 'Mogelijk gemaakt door',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Inloggen bij Confluence',
  'embedded.confluence.login-page.login-button': 'Inloggen bij Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Login-knop',
  'embedded.confluence.login-page.login-text': 'Je moet ingelogd zijn om deze pagina te bekijken',
  'embedded.confluence.login-page.refresh-page-banner': 'Nadat je bent ingelogd, moet deze pagina automatisch vernieuwen. Als dit niet gebeurt, kun je hier klikken om te vernieuwen',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Pagina vernieuwen',
  'embedded.confluence.need-to-log-in-paragraph': 'Je moet ingelogd zijn om deze pagina te bekijken',
  'embedded.confluence.still-having-trouble-paragraph': 'Nog steeds niet gelukt? Zorg ervoor dat cookies van derden zijn ingeschakeld of {link}',
  'embedded.confluence.troubleshooting-link-text': 'raadpleeg deze handleiding voor probleemoplossing.',
  'embedded.confluence.troubleshooting-link.aria-label': 'link naar handleiding voor probleemoplossing'
};